import { LOCALES } from "./locales";

export const messages = {
    [LOCALES.ENGLISH]: {
        password_length: "Password must be between 8 and 30 characters.",
        password_upper_case: "Password must contain at least 1 upper case letter.",
        password_number: "Password must contain at least 1 number.",
        password_symbol: "Password must contain at least 1 special character.",
        password_match: "Passwords must match",
        field_required: "This field is required!",
        invalid_email: "This is not a valid email.",
        invalid_phone: "This is not a valid phone number.",
        invalid_postcode: "This is not a valid post code.",
        invalid_zipcode: "This is not a valid zip code.",
    }
}